{
  "title": "Time Ravage",
  "source": "Explorer's Guide to Wildemount",
  "levelAndSchool": "9th-level necromancy (dunamancy:chronurgy)",
  "level": 9,
  "castingTime": "1 action",
  "range": "90 feet",
  "components": "V, S, M (an hourglass filled with diamond dust worth at least 5,000 gp, which the spell consumes)",
  "duration": "Instantaneous",
  "description": [
    "You target a creature you can see within range, putting its physical form through the devastation of rapid aging. The target must make a Constitution saving throw, taking 10d12 necrotic damage on a failed save, or half as much damage on a successful one. If the save fails, the target also ages to the point where it has only 30 days left before it dies of old age. In this aged state, the target has disadvantage on attack rolls, ability checks, and saving throws, and its walking speed is halved. Only the Wish spell or the Greater Restoration spell cast with a 9th-level spell slot can end these effects and restore the target to its previous age."
  ],
  "spellLists": ["wizard"]
}
